import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-245aff65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header-main" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "app-name" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.appName), 1)
    ]),
    _renderSlot(_ctx.$slots, "rhs-header", {}, undefined, true)
  ]))
}